import maxBy from 'lodash/maxBy';

import { TestCase } from '@qality/common-model';

import Utils from './Utils';

export default {
  getNextId(collection: Array<TestCase>): number {
    const entityWithMaxId = maxBy(collection, function (item) {
      return item.id;
    });

    return Utils.isNilOrEmpty(entityWithMaxId)
      ? 1
      : parseInt(entityWithMaxId.id) + 1;
  },
};
